module.exports = __webpack_public_path__ + "img/cf_orange.625217ef.svg";